import I18N from '@utils/i18n.base';

export const VISIBILITY_PUBLIC = -1;
export const VISIBILITY_PROTECTED = 0;
export const VISIBILITY_PRIVATE = 1;
export const VISIBILITY_SHARED = 2;

export type VisibilityValue =
    | typeof VISIBILITY_PUBLIC
    | typeof VISIBILITY_PROTECTED
    | typeof VISIBILITY_PRIVATE
    | typeof VISIBILITY_SHARED;

export function getVisibilityLabel(visibility: number): string {
    switch (visibility) {
        case VISIBILITY_PUBLIC:
            return I18N.app.public;
        case VISIBILITY_PROTECTED:
            return I18N.app.protected;
        case VISIBILITY_PRIVATE:
            return I18N.app.private;
        case VISIBILITY_SHARED:
            return I18N.app.shared;
        default:
            return I18N.app.unknown;
    }
}

export function getVisibilityDescription(visibility: number): string {
    switch (visibility) {
        case VISIBILITY_PUBLIC:
            return I18N.app.visibilityPublicDescription;
        case VISIBILITY_PROTECTED:
            return I18N.app.visibilityProtectedDescription;
        case VISIBILITY_PRIVATE:
            return I18N.app.visibilityPrivateDescription;
        case VISIBILITY_SHARED:
            return I18N.app.visibilitySharedDescription;
        default:
            return I18N.app.unknown;
    }
}

export function getVisibilityOptions() {
    return [
        { value: String(VISIBILITY_PUBLIC), label: getVisibilityLabel(VISIBILITY_PUBLIC) },
        { value: String(VISIBILITY_PROTECTED), label: getVisibilityLabel(VISIBILITY_PROTECTED) },
        { value: String(VISIBILITY_PRIVATE), label: getVisibilityLabel(VISIBILITY_PRIVATE) },
        { value: String(VISIBILITY_SHARED), label: getVisibilityLabel(VISIBILITY_SHARED) },
    ];
}

export function getVisibilityTone(visibility: number): string {
    switch (visibility) {
        case VISIBILITY_PUBLIC:
            return 'bg-theme-success-soft text-theme-success';
        case VISIBILITY_PROTECTED:
            return 'bg-theme-accent-soft text-theme-active';
        case VISIBILITY_PRIVATE:
            return 'bg-theme-button-secondary text-theme-text-muted';
        case VISIBILITY_SHARED:
            return 'bg-theme-warning-soft text-theme-warning';
        default:
            return 'bg-theme-subtle-bg text-theme-text-muted';
    }
}
